import type { FunctionComponent, ReactNode } from 'react';

import { Pill } from 'components/admin';
import type { TransformationStageT } from 'utils';

import './style.scss';

type PropsT = {
  stages: TransformationStageT[] | undefined;
};

export const TransformationStages: FunctionComponent<PropsT> = ({
  stages,
}) => {
  const nodes: ReactNode[] = [];

  if (stages) {
    for (let i = 0; i < stages.length; ++i) {
      const stage = stages[i];
      if (!stage) throw Error('Internal error');

      const last = i === stages.length - 1;
      nodes.push(
        <Pill key={`${i}/stage/${stage.kind}`} kind="blue">
          {stage.kind} ({stage.durationMin.toFixed(1)} min)
        </Pill>,
      );
      if (!last) {
        nodes.push(
          <div key={`${i}/separator`} styleName="rightArrow">
            &raquo;
          </div>,
        );
      }
    }
  }

  return <div styleName="container">{nodes}</div>;
};
